var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action-button',{attrs:{"disabled":_vm.isNew,"title":"Use this react as homepage","icon":_vm.$icons.homepage},on:{"action":_vm.setHomepage}})}
var staticRenderFns = []

export { render, staticRenderFns }